import { Marked } from 'marked';

export const markdown = new Marked({ async: false, breaks: true });

const LITERAL_TILDE = 'literalTilde';

/**
 * Una tilde suelta (`~5`, `~80~85`) no debe generar tachado. Se registra una
 * extensión inline que reclama la tilde como texto literal: marked evalúa las
 * extensiones antes que sus tokenizers propios, por lo que el tokenizer `del`
 * por defecto (que también acepta `~texto~`) nunca llega a verla y sólo puede
 * matchear `~~texto~~`, conservando su manejo de escapes (`\~`).
 */
markdown.use({
  extensions: [
    {
      name: LITERAL_TILDE,
      level: 'inline',
      start: (src: string) => src.indexOf('~'),
      tokenizer: (src: string) => {
        if (/^~(?!~)/.test(src)) {
          return { type: LITERAL_TILDE, raw: '~' };
        }
        return undefined;
      },
      renderer: () => '~',
    },
  ],
});
